import React from 'react';

import { ConversationsContext } from '.';
import { VenueListConversationsFilter } from '../../graphql/API';
import { useVenueListConversationsQuery } from '../../hooks/reactQuery/chat/useVenueListConversationsQuery';
import useVenueId from '../../hooks/useVenueId';
import { useAppSelector } from '../../redux/hooks';
import { VENUE_MANUAL_TAGS } from '../../utils/venue-tags';

const ConversationsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const venueID = useVenueId();
  const venueState = useAppSelector((state) => state.venue.value);
  const isOnlineBrand = React.useMemo(
    () => venueState?.tags?.includes(VENUE_MANUAL_TAGS.Online),
    [venueState],
  );

  const [venueConversationFilter, setVenueConversationFilter] = React.useState<
    Partial<VenueListConversationsFilter>
  >({ venueID, totalMessagesCount: isOnlineBrand ? 1 : 0, sortbyRecent: true });

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage, revalidateConversations } =
    useVenueListConversationsQuery({ ...venueConversationFilter });

  return (
    <ConversationsContext.Provider
      value={{
        venueConversationFilter,
        data,
        isLoading,
        isFetching,
        hasNextPage,
        fetchNextPage,
        revalidateConversations,
        setVenueConversationFilter,
      }}
    >
      {children}
    </ConversationsContext.Provider>
  );
};

export default ConversationsProvider;
